<template>
	<report-page
		:month-date="true"
		get-url="/bo/report/productmonitoringdashboard/productmonitoringdashboard"
		title="Product Monitoring Dashboard Export"
		export-filename="product_monitoring_dashboard_export"
		:items-per-page="15"
	/>
</template>

<script>
export default {
	name: 'ProductMonitoringDashboardExport',
};
</script>
